// © Microsoft Corporation. All rights reserved.

import { ComponentStyles } from "@microsoft/fast-jss-manager";
import { DesignSystem } from "@microsoft/fast-components-styles-msft";

/** CSS class names to apply to various {CardAction} components */
export interface IconCssClasses {
    /** CSS class for the image icon */
    icon?: string,
    /** CSS class for the inline icon */
    icon_inline?: string
}

/**
 * The main JSS stylesheet for {CardAction}
 */
export const IconStyles: ComponentStyles<IconCssClasses, DesignSystem> = {
    icon: {
        "max-height": "100%",
        "max-width": "100%"
    },
    icon_inline: {
        "&&": {
            width: "auto",
            height: "auto"
        }
    }
};
